import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MaterialModule } from '@core/modules';
import { DeleteMemberAccountComponent } from '../delete-account/delete-member-account/delete-member-account.component'
import { DeleteAccountDialogComponent } from './delete-account-dialog/delete-account-dialog.component';
import { DeleteMemberAccountRoutingModule } from './delete-member-account-routing.module';
import { LogoComponent } from '@shared/components';
import { SetImagePathDirective } from '@shared/directives';

@NgModule({
  declarations: [
    DeleteMemberAccountComponent,
    DeleteAccountDialogComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    LogoComponent,
    DeleteMemberAccountRoutingModule,
    SetImagePathDirective
  ]
})
export class DeleteMemberAccountModule { }
